/**
 * Phase 3.5A — Operator UI exposure flags.
 *
 * These flags control UI VISIBILITY ONLY. They are never authorization.
 * Every screen they reveal is additionally guarded server-side by an
 * active-administrator check inside the underlying RPCs.
 *
 * They must never enable Runtime, composition, applicability, lineage or
 * report watermarking — those remain operational database flags.
 */

/**
 * Reveals /admin/methodology-composition and its Admin navigation entry.
 * Opt-out: enabled unless a build explicitly sets the variable to "false".
 * Previously this was opt-in, so any build that did not inject the variable
 * (e.g. the Dev preview build) rendered an "access denied" screen for real
 * platform administrators. Visibility only — the RPCs still enforce admin.
 */
export const ADMIN_METHODOLOGY_COMPOSITION_UI_ENABLED =
  import.meta.env.VITE_ADMIN_METHODOLOGY_COMPOSITION_UI !== "false";

/**
 * Reveals the read-only Reviewer "Assessment Profile" panel.
 * UI-only: it does not enable composition or change reviewer scoring.
 */
export const REVIEWER_ASSESSMENT_PROFILE_UI_ENABLED =
  import.meta.env.VITE_REVIEWER_ASSESSMENT_PROFILE_UI !== "false";


/** Human-readable inventory rendered by the read-only Feature State panel. */
export const UI_EXPOSURE_FLAGS = [
  {
    key: "ADMIN_METHODOLOGY_COMPOSITION_UI_ENABLED",
    label: "Methodology & Composition console",
    value: ADMIN_METHODOLOGY_COMPOSITION_UI_ENABLED,
    scope: "UI only",
  },
  {
    key: "REVIEWER_ASSESSMENT_PROFILE_UI_ENABLED",
    label: "Reviewer Assessment Profile panel",
    value: REVIEWER_ASSESSMENT_PROFILE_UI_ENABLED,
    scope: "UI only",
  },
] as const;
